import { useObserver } from "mobx-react";
import { MdOutlineAutoAwesome } from "react-icons/md";

export default function TextArea(props) {
  return useObserver(() => (
    <>
      <div className="flex flex-col gap-3 mb-4 text-lg">
        <label className=" flex justify-between w-full">
          <span className="  ml-4">{props.label}</span>{" "}
          {/* <span
            className="text-primary underline font-bold flex items-center gap-2 cursor-pointer"
            onClick={props.onClick}
          >
            <MdOutlineAutoAwesome />
            Auto generate
          </span> */}
        </label>
        <textarea
          maxLength={props.maxLength}
          required={props.required}
          value={props.value}
          placeholder={props.placeholder}
          onChange={(e) => props.action(e)}
          className="border  px-4 rounded-lg Auto generate h-40 border-[#c9c9c9] scrollbar-hide p-3  "
        />
      </div>
    </>
  ));
}
